var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../../app/Locale';
import Button from '../../Components/ComponentButton';
import BookModal from '../Purchase/PurchaseModal';
import NemAdgangModal from '../Account/EIDModal/EIDModal';
import DocumentButton from '../../../documents/Document/DocumentButton';
const ProductButton = ({ product, theme, user, allPartners, allProducts, title = false, onClick = null, preSelectedPurchaseType = false, selectedType = null }) => {
    const [showBookModal, toggleBookModal] = useState(false);
    const [showNemAdgangModal, toggleNemAdgangModal] = useState(false);
    const [isLoading, toggleLoading] = useState(false);
    const goToProduct = () => __awaiter(void 0, void 0, void 0, function* () {
        if (onClick) {
            yield onClick();
        }
        if (product.isExternal) {
            toggleLoading(true);
            window.location.href = product.link;
            return;
        }
        // If the product is not digitalized, book legal consultation with a lawyer
        if (!product.isActive) {
            toggleBookModal(true);
            return;
        }
        // If nem adgang is required for the product, show the nem adgang modal.
        if (product.isNemAdgangRequired) {
            toggleNemAdgangModal(true);
            return;
        }
        // If all checks succeed, redirect to the product.
        toggleLoading(true);
        const queryParams = selectedType == null ? '' : `?purchaseType=${selectedType}`;
        window.location.href = `${product.path}${queryParams}`;
    });
    return (_jsxs("div", { children: [showBookModal && (_jsx(BookModal, { onFinish: () => toggleBookModal(false), closeModal: () => toggleBookModal(false), allPartners: allPartners, user: user, selectedProduct: product.machineName, allProducts: allProducts })), showNemAdgangModal && (_jsx(NemAdgangModal, { closeModal: () => toggleNemAdgangModal(false), redirect: window.location.href })), product.document === undefined && (_jsx(Button, { title: title || T.translate('products_overview.products.create_button'), classes: theme, onClick: goToProduct, isLoading: isLoading, id: `productButton_${product.machineName}` })), product.document !== undefined && (_jsx(DocumentButton, { path: product.documentPath, action: product.documentAction, document: product.document, statusText: product.documentStatusText, isNemIdValidated: !product.isNemAdgangRequired, classes: theme, overrideButtonText: title, preSelectedPurchaseType: preSelectedPurchaseType }))] }));
};
ProductButton.propTypes = {
    product: PropTypes.shape({
        documentPath: PropTypes.string,
        documentAction: PropTypes.string,
        documentStatusText: PropTypes.string,
        document: PropTypes.object,
        machineName: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        isNemAdgangRequired: PropTypes.bool.isRequired,
        path: PropTypes.string.isRequired,
        isExternal: PropTypes.bool,
        link: PropTypes.string
    }),
    theme: PropTypes.string,
    allPartners: PropTypes.array.isRequired,
    user: PropTypes.object,
    allProducts: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    title: PropTypes.string,
    onClick: PropTypes.func,
    preSelectedPurchaseType: PropTypes.bool,
    selectedType: PropTypes.string
};
export default ProductButton;
